var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "developer-settings" }, [
    _c("div", { staticClass: "section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "title" }, [
          _c("span", { staticClass: "material-icons" }, [_vm._v("vpn_key")]),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("settings.apiAccessTitle")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("settings.apiAccessSubtitles"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle token-warning" }, [
          _vm._v(_vm._s(_vm.$t("developer.tokenGenerateWarning"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "token-box" }, [
        _c(
          "div",
          { staticClass: "token-value", class: { empty: !_vm.accessToken } },
          [
            _vm.accessToken
              ? _c("span", [_vm._v(_vm._s(_vm.truncatedToken))])
              : _c("span", { staticClass: "no-token" }, [
                  _vm._v(_vm._s(_vm.$t("developer.noToken"))),
                ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "token-actions" },
          [
            _c(
              "a-button",
              {
                attrs: { icon: "sync", loading: _vm.tokenLoading },
                on: { click: _vm.generateToken },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.generateToken")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { icon: "copy", disabled: !_vm.accessToken },
                on: { click: _vm.copyToken },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.copyToken")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { icon: "book" }, on: { click: _vm.goToApiDoc } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.ApiDoc")) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("div", { staticClass: "section-header" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", { staticClass: "material-icons" }, [_vm._v("webhook")]),
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("developer.webhookUrls")) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("developer.webhookUrlsDescription"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "webhook-list" },
          [
            _vm._l(_vm.webhookUrls, function (item, idx) {
              return _c(
                "div",
                { key: idx, staticClass: "webhook-item" },
                [
                  _c("a-input", {
                    staticClass: "webhook-name-input",
                    attrs: {
                      placeholder: _vm.$t("developer.webhookNamePlaceholder"),
                    },
                    model: {
                      value: item.name,
                      callback: function ($$v) {
                        _vm.$set(item, "name", $$v)
                      },
                      expression: "item.name",
                    },
                  }),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "webhook-url-input",
                    attrs: {
                      placeholder: _vm.$t("developer.webhookUrlPlaceholder"),
                    },
                    model: {
                      value: item.url,
                      callback: function ($$v) {
                        _vm.$set(item, "url", $$v)
                      },
                      expression: "item.url",
                    },
                  }),
                  _vm._v(" "),
                  _c("a-button", {
                    attrs: { type: "danger", icon: "delete" },
                    on: {
                      click: function ($event) {
                        return _vm.removeWebhook(idx)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "add-webhook-btn",
                attrs: { type: "dashed", icon: "plus" },
                on: { click: _vm.addWebhook },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("developer.addWebhook")) +
                    "\n            "
                ),
              ]
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "a-button",
          {
            staticClass: "save-btn",
            attrs: { type: "primary", loading: _vm.saving },
            on: { click: _vm.save },
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.$t("chatbotv2.save")) + "\n        "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "title" }, [
          _c("span", { staticClass: "material-icons" }, [
            _vm._v("integration_instructions"),
          ]),
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("developer.messagingApi")) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("developer.messagingApiDescription"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "api-docs" }, [
        _c("div", { staticClass: "doc-group" }, [
          _c("div", { staticClass: "doc-group-title" }, [
            _c("span", { staticClass: "method-badge post" }, [_vm._v("POST")]),
            _vm._v(" "),
            _c("span", { staticClass: "endpoint-path" }, [
              _vm._v(_vm._s(_vm.messagingEndpointPath)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "doc-group-desc" }, [
            _vm._v(_vm._s(_vm.$t("developer.sendMessageDesc"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "doc-group-desc doc-params" }, [
            _vm._v(_vm._s(_vm.$t("developer.fromUserIdParamsDesc"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "doc-group-desc doc-params" }, [
            _c("span", { staticClass: "param-label" }, [_vm._v(":contactId")]),
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t("developer.contactIdParamsDesc")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "doc-block" }, [
            _c("div", { staticClass: "doc-title" }, [
              _vm._v(_vm._s(_vm.$t("developer.authentication"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "code-block" }, [
              _c(
                "div",
                { staticClass: "code-copy-row" },
                [
                  _c("pre", { staticClass: "language-bash" }, [
                    _c("code", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.highlightBash(
                            "Authorization: Bearer " +
                              (_vm.accessToken
                                ? _vm.truncatedToken
                                : "<access_token>")
                          )
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("a-button", {
                    attrs: { size: "small", icon: "copy" },
                    on: { click: _vm.copyAuthHeader },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "doc-block" },
            [
              _c("div", { staticClass: "doc-title" }, [
                _vm._v(_vm._s(_vm.$t("developer.requestBody"))),
              ]),
              _vm._v(" "),
              _c(
                "a-tabs",
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "text",
                      attrs: { tab: _vm.$t("developer.tabPayloadText") },
                    },
                    [
                      _c("div", { staticClass: "code-block" }, [
                        _c("pre", { staticClass: "language-json" }, [
                          _c("code", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightJson(_vm.textExample)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tab-pane",
                    {
                      key: "image",
                      attrs: { tab: _vm.$t("developer.tabPayloadImage") },
                    },
                    [
                      _c("div", { staticClass: "code-block" }, [
                        _c("pre", { staticClass: "language-json" }, [
                          _c("code", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightJson(_vm.imageExample)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tab-pane",
                    {
                      key: "video",
                      attrs: { tab: _vm.$t("developer.tabPayloadVideo") },
                    },
                    [
                      _c("div", { staticClass: "code-block" }, [
                        _c("pre", { staticClass: "language-json" }, [
                          _c("code", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightJson(_vm.videoExample)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tab-pane",
                    {
                      key: "document",
                      attrs: { tab: _vm.$t("developer.tabPayloadDocument") },
                    },
                    [
                      _c("div", { staticClass: "code-block" }, [
                        _c("pre", { staticClass: "language-json" }, [
                          _c("code", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightJson(_vm.documentExample)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "doc-block" }, [
            _c("div", { staticClass: "doc-title" }, [
              _vm._v(_vm._s(_vm.$t("developer.curlExample"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "code-block" }, [
              _c(
                "div",
                { staticClass: "code-copy-row" },
                [
                  _c("pre", { staticClass: "language-bash" }, [
                    _c("code", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.highlightBash(_vm.curlExampleDisplay)
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("a-button", {
                    attrs: { size: "small", icon: "copy" },
                    on: { click: _vm.copyCurl },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "doc-group" }, [
          _c("div", { staticClass: "doc-group-title" }, [
            _c("span", { staticClass: "method-badge post" }, [_vm._v("POST")]),
            _vm._v(" "),
            _c("span", { staticClass: "endpoint-path" }, [
              _vm._v(_vm._s(_vm.$t("developer.yourWebhookUrl"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "doc-group-desc" }, [
            _vm._v(_vm._s(_vm.$t("developer.webhookPayloadDesc"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "doc-block" },
            [
              _c("div", { staticClass: "doc-title" }, [
                _vm._v(_vm._s(_vm.$t("developer.webhookPayload"))),
              ]),
              _vm._v(" "),
              _c(
                "a-tabs",
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "received",
                      attrs: { tab: _vm.$t("developer.webhookEventReceived") },
                    },
                    [
                      _c("div", { staticClass: "code-block" }, [
                        _c("pre", { staticClass: "language-json" }, [
                          _c("code", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightJson(_vm.webhookPayloadExample)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tab-pane",
                    {
                      key: "sent",
                      attrs: { tab: _vm.$t("developer.webhookEventSent") },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "doc-group-desc",
                          staticStyle: { "margin-bottom": "8px" },
                        },
                        [_vm._v(_vm._s(_vm.$t("developer.webhookSentDesc")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "code-block" }, [
                        _c("pre", { staticClass: "language-json" }, [
                          _c("code", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.highlightJson(_vm.webhookSentPayloadExample)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }